// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import md5 from 'js-md5'
import './plugins/element.js'
import './assets/css/global.css'
import axios from 'axios'

Vue.prototype.$md5 = md5

Vue.config.productionTip = false

axios.defaults.timeout = 50000
axios.defaults.withCredentials = true
axios.defaults.crossDomain = true
axios.defaults.headers.common['Access-Control-Allow-Origin'] = true
axios.defaults.headers.post['Content-Type'] = 'application/json'
if (window.location.hostname === 'localhost') {
  axios.defaults.baseURL = 'http://localhost:9001/api/manager'
} else {
  axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/api/v1'
}
axios.interceptors.request.use(config => {
  var isLogin = config.url.includes('login')
  if (!isLogin) {
    config.headers.Authorization = window.sessionStorage.getItem('token')
  }
  return config
})

axios.interceptors.response.use(function (response) {
  return response
}, error => {
  let response = error.response
  if (response && response.data) {
    const status = response.data.code
    if (status === -11) {
      router.push('/login')
    }
  }
  return Promise.reject(error)
})

Vue.prototype.$http = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js